import classNames from 'classnames';
import ParticipantsListForm, { ParticipantsListFormRawProps } from '@/shared/components/shared/ParticipantsListForm';

type Props = React.HTMLAttributes<HTMLElement> & {
    participantsListSectionProps: ParticipantsListFormRawProps;
};

function ParticipantsListSection({ participantsListSectionProps, ...props }: Props) {
    return (
        <section
            {...props}
            className={classNames('participants-list-section js-header-theme-trigger', props.className)}
            data-theme="dark"
        >
            <div className="wrapper">
                <ParticipantsListForm {...participantsListSectionProps} />
            </div>
        </section>
    );
}

export default ParticipantsListSection;
